import { renderClassName } from "@/utils/renderClassName";

type TextBlockProps = {
  className?: string;
  children: React.ReactNode;
};

const TextBlock = ({ className, children }: TextBlockProps) => {
  return (
    <div className={renderClassName("text-block", className)}>{children}</div>
  );
};

export default TextBlock;
